import { parseJwt } from "@libs/utils/helpers/parseJwt";
import type { SessionProps } from "./types";

export const isExpiredToken = (token: string) => {
	if (!token) return true;

	const { exp } = parseJwt(token);

	//it converts current timestamp to seconds format
	const currentTimestamp = Math.floor(Date.now() / 1000);
	return exp < currentTimestamp;
};

export const checkSessionValidity = (accessToken: string) => {
	if (!accessToken) return false;
	if (isExpiredToken(accessToken)) return false;

	return true;
};

export const shouldRefreshTokens = (
	accessToken: string,
	refreshToken: string,
) => {
	if (!refreshToken) return false;
	if (isExpiredToken(refreshToken)) return false;

	// If access token is expired, we need to refresh
	return isExpiredToken(accessToken);
};

export const isJwt = (token: string) => {
	if (typeof token !== "string") {
		return false;
	}

	const parts = token.split(".");

	if (parts.length !== 3) {
		return false;
	}

	try {
		const header = JSON.parse(atob(parts[0]));
		const payload = JSON.parse(atob(parts[1]));

		if (
			typeof header !== "object" ||
			header === null ||
			typeof payload !== "object" ||
			payload === null
		) {
			return false;
		}

		// A simple check for common JWT header properties
		if (!header.alg || !header.typ || header.typ !== "JWT") {
			// This is a soft check, some valid JWTs might not have these
			// but it's a good indicator.
		}
	} catch (_) {
		// If decoding or parsing fails, it's not a valid JWT structure.
		return false;
	}

	return true;
};

//TODO: remover pós experimento auth provider
export const hasValidSession = ({
	access_token,
	refresh_token,
}: SessionProps) => {
	if (!access_token) return false;

	if (!refresh_token) {
		return !isExpiredToken(access_token);
	}

	const isAccessExpired = isExpiredToken(access_token);
	const isRefreshExpired = isExpiredToken(refresh_token);

	return !(isAccessExpired || isRefreshExpired);
};

export const generateOneHundredTwentyDays = () => {
	const oneHundredTwentyDays = new Date();
	oneHundredTwentyDays.setDate(oneHundredTwentyDays.getDate() + 120);

	return oneHundredTwentyDays;
};
